import { auth } from '../../firebase';
import { callFunctionViaFetch } from '../../utils/callFunctionViaFetch';
import type { VibeClaimCredential } from './vibeClaimLinks';

// europe-west3 callables from functions/vibeWebGame.js, called over fetch for
// the same Hermes reason documented in utils/callFunctionViaFetch.ts.
const BASE = 'https://europe-west3-triptribe-8babd.cloudfunctions.net';

export type VibeClaimOutcome = 'submitted' | 'already_completed' | 'round_closed';

export type VibeClaimResult = {
  outcome: VibeClaimOutcome;
  dateKey: string;
  /** true at/after 13:00 Berlin: matching runs right away. false: first results at 13:00. */
  resultsReady: boolean;
  replay: boolean;
  round: { dateKey: string; phase: 'before_open' | 'open' | 'revealed'; revealAt: string };
};

export type VibeCodeCheck =
  | { valid: false }
  | {
      valid: true;
      dateKey: string;
      roundIsCurrent: boolean;
      claimStatus: 'unclaimed' | 'claimed';
    };

export async function claimVibeWebSession(
  request: VibeClaimCredential | { method: 'verified_email' },
): Promise<VibeClaimResult> {
  const user = auth.currentUser;
  if (!user) throw new Error('Not signed in.');
  const idToken = await user.getIdToken();
  return callFunctionViaFetch<VibeClaimResult>(`${BASE}/claimVibeWebSessionEu`, request as Record<string, unknown>, { idToken });
}

/** Public, rate-limited: is this recovery code real and still for today? */
export async function checkVibeRecoveryCode(code: string): Promise<VibeCodeCheck> {
  return callFunctionViaFetch<VibeCodeCheck>(`${BASE}/checkVibeRecoveryCodeEu`, { code });
}
